import { render } from "./StepNumber.vue?vue&type=template&id=9ec4b5fa&scoped=true"
import script from "./StepNumber.vue?vue&type=script&lang=js"
export * from "./StepNumber.vue?vue&type=script&lang=js"

import "./StepNumber.vue?vue&type=style&index=0&id=9ec4b5fa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ec4b5fa"]])

export default __exports__